import { Table, Tag } from "antd";
import { useEffect, useState } from "react";
import moment from "moment";
import { planHistoryApi } from "../../config/Api";
import { rupees } from "./PlanOptions";

const STATUS = {
    current: { color: 'green', label: 'Current' },
    scheduled: { color: 'blue', label: 'Starts later' },
    replaced: { color: 'default', label: 'Replaced' },
    ended: { color: 'red', label: 'Ended' },
}
const showDate = (date) => (date ? moment(date).format('DD MMM YYYY') : '')

// every plan the doctor has had, newest first, Free periods included (Profile and My Plan)
// reload: change it to fetch again (e.g. after a payment)
export const PlanHistory = ({ reload }) => {
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        planHistoryApi()
            .then((res) => setRows(res.data.data))
            .catch(() => {})
            .finally(() => setLoading(false))
    }, [reload])

    return (
        <Table
            rowKey="id"
            loading={loading}
            dataSource={rows}
            size="middle"
            pagination={{ pageSize: 10, hideOnSinglePage: true }}
            locale={{ emptyText: 'No plans yet' }}
            scroll={{ x: 'max-content' }}
            columns={[
                { title: 'Plan', dataIndex: 'plan', render: (plan, row) => <b>{plan}</b> },
                {
                    title: 'Billing', dataIndex: 'billing_cycle',
                    render: (cycle) => cycle === 'free' ? 'Free' : cycle.charAt(0).toUpperCase() + cycle.slice(1),
                },
                {
                    title: 'Period', key: 'period',
                    render: (_, row) => `${showDate(row.starts_at)} to ${row.ends_at ? showDate(row.ends_at) : 'no end date'}`,
                },
                { title: 'Paid', dataIndex: 'amount', render: (amount, row) => (row.is_free ? <span className="text-muted">Free</span> : row.set_by_admin ? '-' : rupees(amount)) },
                { title: 'Credit used', dataIndex: 'credit_applied', render: (credit) => (credit ? rupees(credit) : '-') },
                { title: 'Status', dataIndex: 'status', render: (status) => <Tag color={STATUS[status]?.color}>{STATUS[status]?.label || status}</Tag> },
                { title: 'Payment ID', dataIndex: 'razorpay_payment_id', render: (id) => <span className="text-muted" style={{ fontSize: 12 }}>{id || '-'}</span> },
            ]}
        />
    )
}
